<template>
  <div class="organizational-list">
    <div class="table-header custom-tree-node">
      <span class="name">所在机构</span>
      <span class="default">默认机构</span>
    </div>
    <el-tree
      ref="tree"
      node-key="depCode"
      :props="props"
      :load="loadNode"
      lazy
      :expand-on-click-node="false">
       <span class="custom-tree-node" slot-scope="{ node, data }">
        <span class="name">
          <el-checkbox :value="data.checked" @change="handleCheckChange(data)" :disabled="disabled" :indeterminate="data.isIndeterminate"></el-checkbox>
          {{ data.name }}
        </span>
        <span class="default">
            <el-checkbox :value="data.isDefault" :disabled="data.isDisabled || disabled" @change="changeDefault(data)"></el-checkbox>
        </span>
      </span>
    </el-tree>
  </div>
</template>
<script>

export default {
  name: 'list',
  props: {
    departId: {
      type: String
    },
    defaultDepart: {
      type: String
    },
    disabled: {
      Boolean,
      default: false
    }
  },
  data() {
    return {
      props: {
        label: 'name',
        children: 'childRepDepConfigs'
      },
      departData: [],
      departNodeData: [],
      strictly: true
    };
  },
  methods: {
    handleCheckChange(data) {
      let index = this.departData.indexOf(data.depCode);
      if (index > -1) {
        data.isDisabled = true;
        data.checked = false;
        data.isDefault = false;
        this.departData.splice(index, 1);
        // this.departNodeData.splice(index, 1);
      }
      else {
        this.departData.push(data.depCode);
        // this.departNodeData.push(data);
        data.isDisabled = false;
        data.checked = true;
      }
      this.$refs.tree.updateKeyChildren(data.id, data);
      this.$emit('toSelect', data.depCode);
      this.judgeCheck();
    },
    judgeCheck(count) {
      if(count === 0){
        this.departData = this.departId.split(',')
      }
      this.departNodeData && this.departNodeData.length > 0 && this.departNodeData.forEach( node =>{
        node.checked = false;
        node.isIndeterminate = false;
      })
      this.departData && this.departData.length > 0 && this.departData.forEach( code => {
        let depLevel = this.getDepLevel(code)
        this.departNodeData && this.departNodeData.length > 0 && this.departNodeData.forEach( (item, index) =>{
          if(depLevel > 2){
            for(let i = 2; i < depLevel; i = i + 2){
              let num = 12 - i;
              let str = '';
              for(let j=0;j<num;j++){
                str += '0'
              }
              if(item.depCode === code.substring(0, i) + str && this.departData.indexOf(item.depCode) === -1){
                item.checked = true
                item.isIndeterminate = true;
                this.$set(this.departNodeData, index, item)
              }
            }
          }
          if(item.depCode === code){
            item.checked = true;
            item.isIndeterminate = false;
          }
        })
      })
    },
    /**
     * 获取级别depCode12位数字
     */
    getDepLevel(depCode) {
      // 省
      if (depCode.substring(2, 12) === '0000000000') {
        return 2;
      }
      // 市
      if (depCode.substring(4, 12) === '00000000') {
        return 4;
      }
      // 县区
      if (depCode.substring(6, 12) === '000000') {
        return 6;
      }
      // 街道
      if (
        depCode.substring(8, 12) === '0000'
        || depCode.substring(9, 12) === '000'
      ) {
        return 8;
      }
      // 社区
      return 10;
    },
    changeDefault(data) {
      this.departNodeData.forEach((item, index) => {
        this.departNodeData[index].isDefault = false;
        this.$refs.tree.updateKeyChildren(item.id, this.departNodeData[index]);
      });
      data.isDefault = true;
      this.$refs.tree.updateKeyChildren(data.id, data);
      this.$emit('defaultSelect', data.depCode);
    },
    loadNode(node, resolve) { //  加载树
      let _this = this;
      if (node.level === 0) {
        this.departData = [];
        this.departNodeData = [];
        this.$services.post({
          type: 'ORGANIZATIONALMANAGEMENT',
          url: 'getDepartList'
        }).then(res => {
          res.bean.forEach(item => {
            if (this.departId.split(',').indexOf(item.depCode) > -1) {
              item.isDisabled = false;
              item.checked = true;
              this.departData.push(item.depCode);

            }
            else {
              item.isDisabled = true;
              item.checked = false;
            }
            item.isDefault = this.defaultDepart === item.depCode;
            this.departNodeData.push(item);
          });
          if(this.departData.length === 0){
            this.judgeCheck(0);
          }else{
            this.judgeCheck();
          }
          return resolve(res.bean);
        });
      }
      if (node.level > 0) {
        _this.$services.post({
          type: 'ORGANIZATIONALMANAGEMENT',
          url: 'getListAllChildDepAjax',
          params: { depCode: node.data.depCode }
        }).then(res => {
          if (res.bean.length) {
            res.bean.forEach(item => {
              if (this.departId.split(',').indexOf(item.depCode) > -1) {
                item.isDisabled = false;
                item.checked = true;
                if(this.departData.indexOf(item.depCode) === -1){
                  this.departData.push(item.depCode);
                }
              }
              else {
                item.isDisabled = true;
                item.checked = false;
              }
              item.isDefault = this.defaultDepart === item.depCode;
              this.departNodeData.push(item);
            });
          }
          this.judgeCheck();
          return resolve(res.bean);
        });
      }
    },
    updateKeyChildren(keys, treeData) {
      this.$refs.tree.updateKeyChildren(keys, treeData);
    }
  }
};
</script>
<style lang="scss">
.organizational-list {
  width: auto;

  .table-header {
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-bottom: 1px solid #ebeef5;
    color: #909399;
    font-weight: 600;
    font-size: 14px;

    .name {
      display: inline-block;
      width: calc(100% - 100px);
    }

    .default {
      display: inline-block;
      width: 100px;
    }
  }

  .el-tree {
    font-size: 14px;
    color: #606266;

    .el-tree__empty-block {
      border-bottom: 1px solid #ebeef5;
    }

    .el-tree-node__content {
      height: 61px;
      border-bottom: 1px solid #ebeef5;
    }
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;

    .default {
      display: inline-block;
      width: 100px;
      text-align: center;
      background: white;
    }

    .name {
      display: inline-block;
      max-width: 200px;
    }
  }

  .el-tree-node__content:hover .default, .el-tree-node:focus > .el-tree-node__content .default {
    background-color: #f5f7fa;
  }
}
</style>
